import React from "react";
import { connect } from "react-redux";
import ClaimHeader from './Components/ClaimHeader/ClaimHeader'
import ClaimChecks from '../../../components/ClaimChecks/index.es6'
import { mergeUploadedClaim, normaliseChecklist } from '../../../components/ClaimChecks/claimChecksLib.es6'
import ClaimDetails from './Components/ClaimDetails/ClaimDetails'
import ClaimDocuments from './Components/ClaimDocuments/ClaimDocuments'
import ClaimExpenses from './Components/ClaimExpenses/ClaimExpenses'
import ClaimAudit from "./Components/ClaimAudit/ClaimAudit";
import ClaimActionButtons from './Components/ClaimActionButtons'
import * as actions from "./Redux/actions"
import BoxInc from "../../../shared-ui/BoxInc/Index";
import ButtonInc from '../../../shared-ui/ButtonInc';
import AddClaimNotes from "./Components/ClaimDetails/AddClaimNotes";
import ClaimNotes from "./Components/ClaimDetails/ClaimNotes";
import AddClaimDocuments from "./Components/ClaimDocuments/AddClaimDocuments";
import AddClaimExpense from "./Components/ClaimExpenses/AddClaimExpense";
import DeleteClaimExpense from "./Components/ClaimExpenses/DeleteClaimExpense";
import EditClaimDetails from "./Components/ClaimExpenses/EditClaimDetails";
import AutoInvoiceSummary from "./Components/ClaimExpenses/AutoInvoiceSummary";
import DeleteClaimDocument from "./Components/ClaimDocuments/DeleteClaimDocument";
import AddClaimFacilityNotes from "./Components/ClaimDetails/AddClaimFacilityNotes";
import find from 'lodash/find';
import { getPartnerGuid, hasAuthourity } from "../../../lib/access.es6";
import { ClaimTypeEnum, ClaimActionEnum, ClaimStatusEnum } from "../lib/enum";
import { hashHistory } from 'react-router';
import DownloadDocument from "../../../components/DownloadDocument/DownloadDocument";
import * as documentActions from '../../../containers/DocumentGeneration/actions.es6';
import LocalizedStrings from 'react-localization';
import { localisedText } from "../../../lib/localisation.es6";
import WaitingPeriodApprovalReason from "./Components/ClaimActionButtons/WaitingPeriodApprovalReason";
import { OLD_MUTUAL_MALAWI_FUNERAL_BENEFITS } from "../../../lib/constants";
import { getPolicyByGuidDcp, createExpense } from "../../../lib/requests.es6";
import { buildBenefitUsagePayloads } from "./lib/benefitInvoices";



class ClaimsProcessing extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      labels: new LocalizedStrings(localisedText),
      openClaimNotesDialog: false,
      openClaimFacilityNotesDialog: false,
      openClaimDocumentsDialog: false,
      openClaimExpenseDialog: false,
      openEditClaimExpenseDialog: false,
      description: "",
      expanded: false,
      missingDocs: false,
      claimToDownload: null,
      openClaimWaitingPeriodDialog: false,
      policy: null,
      policyLoading: false,
      autoInvoiceSummary: {
        open: false,
        creating: false,
        total: 0,
        created: [],
        failures: [],
        invoiceNumber: null,
      },
    };

    // Set when the agent finalises documentation, so componentDidUpdate knows to
    // auto-create the benefit-usage invoices once the claim reaches
    // Decision_Pending.
    this.autoInvoiceRequested = false;
    this.autoInvoiceInFlight = false;
  }

  componentWillMount() {
    let claim_guid = this.props.params.claim_guid;
    this.props.dispatch(
      actions.getClaimProcessingDcpRequest({
        guid: claim_guid,
      })
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.openClaimDocumentsDialog === true &&
      this.state.openClaimDocumentsDialog === false
    ) {
      let claim_guid = this.props.params.claim_guid;
      this.props.dispatch(
        actions.getClaimProcessingDcpRequest({
          guid: claim_guid,
        })
      );
    }

    const prevClaim = prevProps.claimProcessingv2Data.claimsProcessingDcp;
    const claim = this.props.claimProcessingv2Data.claimsProcessingDcp;

    if (
      claim &&
      claim !== prevClaim && // claim just loaded or changed
      claim.is_on_grace_period &&
      claim.policy_guid
    ) {
      this.fetchPolicy(claim.policy_guid);
    }

    // After a document upload, the endpoint returns the updated claim (read from
    // the write-master). Merge its documents into the store so the docs table
    // and the missing-docs check refresh immediately — without waiting on the
    // replica-lagged refetch that previously forced a manual page refresh.
    const prevAdded = prevProps.claimProcessingv2Data.addedTemplateDocument;
    const added = this.props.claimProcessingv2Data.addedTemplateDocument;
    if (claim && added && added !== prevAdded && added.claim_documents) {
      this.props.dispatch(
        actions.getClaimProcessingDcpSuccess(mergeUploadedClaim(claim, added))
      );
    }

    // Auto-create the invoices as soon as our docs-finalisation SUCCEEDS. The
    // action response (ClaimAction) is loaded from the write-master, so it
    // reliably carries the Decision_Pending status and the claim benefits — we
    // don't depend on the replica-lagged status refetch to fire.
    const prevActionSuccess = prevProps.claimProcessingv2Data.ClaimActionSuccess;
    const actionSuccess = this.props.claimProcessingv2Data.ClaimActionSuccess;
    if (this.autoInvoiceRequested && !prevActionSuccess && actionSuccess) {
      this.autoInvoiceRequested = false;
      const actionClaim = this.props.claimProcessingv2Data.ClaimAction;
      const storeClaim = this.props.claimProcessingv2Data.claimsProcessingDcp;
      if (
        actionClaim &&
        actionClaim.status === ClaimStatusEnum.Decision_Pending
      ) {
        // The confirm response omits benefit_usages; supplement from the store
        // claim so the idempotency filter still works.
        const claimForInvoicing = Object.assign({}, actionClaim, {
          benefit_usages:
            (storeClaim && storeClaim.benefit_usages) ||
            actionClaim.benefit_usages ||
            [],
        });
        this.autoCreateBenefitUsages(claimForInvoicing);
      }
    }
  }


  // Dispatch a claim action; remember when it is a docs finalisation so that the
  // resulting Decision_Pending transition triggers auto-creation of the invoices.
  handleSubmitClaimAction(claimActionPayload) {
    if (claimActionPayload.claim_action === ClaimActionEnum.complete_docs) {
      this.autoInvoiceRequested = true;
    }
    this.props.dispatch(actions.claimActionRequest(claimActionPayload));
  }

  // Create one benefit usage per claim benefit (primary + bundled add-ons),
  // sharing a single claim-level invoice number, each with its own expense code.
  // Sequential on purpose: the backend loads-mutates-saves the whole claim per
  // call, so parallel writes would clobber each other.
  async autoCreateBenefitUsages(claim) {
    if (this.autoInvoiceInFlight) return;
    const payloads = buildBenefitUsagePayloads(claim, this.state.policy);
    if (!payloads.length) return;

    this.autoInvoiceInFlight = true;
    const created = [];
    const failures = [];
    const invoiceNumber = payloads[0] ? payloads[0].invoice_number : null;

    // Reflect progress in the summary dialog; called before, during and after.
    const pushSummary = (creating) => {
      this.setState({
        autoInvoiceSummary: {
          open: true,
          creating: creating,
          created: created.slice(),
          failures: failures.slice(),
          invoiceNumber: invoiceNumber,
          total: payloads.length,
        },
      });
    };

    // Open the dialog immediately in a progress state so the agent sees it start.
    pushSummary(true);

    // Each successful create returns the claim read from master (with its
    // benefit usages), so we merge it into the store after every call — the new
    // invoice row shows immediately, with no replica-lagged GET to wait on.
    let currentClaim = claim;

    try {
      for (let i = 0; i < payloads.length; i++) {
        try {
          const response = await createExpense(payloads[i]);
          created.push(payloads[i]);
          if (response && response.data) {
            currentClaim = {
              ...response.data,
              // The create read-back omits claim_notes; keep what we have.
              claim_notes: currentClaim.claim_notes,
            };
            this.props.dispatch(
              actions.getClaimProcessingDcpSuccess(currentClaim)
            );
          }
        } catch (e) {
          const data = e && e.response ? e.response.data : null;
          let message = "Could not be created";
          if (data) {
            if (typeof data === "string") {
              message = data;
            } else if (data.message) {
              message = Array.isArray(data.message)
                ? data.message.join(", ")
                : data.message;
            } else if (data.error) {
              message = data.error;
            }
          }
          failures.push({
            benefit_type: payloads[i].benefit_type,
            message: message,
          });
          console.error(
            "Auto-invoice creation failed for benefit",
            payloads[i].benefit_type,
            e
          );
        }
        // Live progress update after each attempt.
        pushSummary(true);
      }
    } finally {
      this.autoInvoiceInFlight = false;
      // Settle the dialog into its final summary state.
      pushSummary(false);
      // The per-create merges already populated the table. But the finalise
      // saga also fires its own replica-lagged GET after confirm, which can land
      // now and briefly overwrite the store with a claim missing these usages.
      // Re-assert the master claim for a few seconds if that happens.
      if (created.length) {
        const expected = currentClaim.benefit_usages
          ? currentClaim.benefit_usages.length
          : 0;
        this.reassertClaimState(currentClaim, expected);
      }
    }
  }

  // Defend the just-merged claim against a stale replica refetch: if the store's
  // claim (same claim) briefly shows fewer benefit usages than the master claim
  // we merged in, restore it. Self-heals once and stops when consistent.
  reassertClaimState(authoritativeClaim, expectedUsageCount) {
    let attempts = 0;
    const tick = () => {
      attempts += 1;
      const current = this.props.claimProcessingv2Data.claimsProcessingDcp;
      const sameClaim =
        current && authoritativeClaim && current.guid === authoritativeClaim.guid;
      const count =
        current && current.benefit_usages ? current.benefit_usages.length : 0;
      if (sameClaim && count < expectedUsageCount) {
        this.props.dispatch(
          actions.getClaimProcessingDcpSuccess(authoritativeClaim)
        );
      }
      if (attempts < 6) {
        setTimeout(tick, 700);
      }
    };
    setTimeout(tick, 700);
  }

  fetchPolicy = async (policyGuid) => {
    try {
      this.setState({ policyLoading: true });

      // Call the API directly
      const response = await getPolicyByGuidDcp({ policy_guid: policyGuid });
      const policy = response.data;

      this.setState({ policy, policyLoading: false });
    } catch (error) {
      console.error("Error fetching policy:", error);
      this.setState({ policy: null, policyLoading: false });
    }
  };

  toggleClaimNotesDialog() {
    this.setState({ openClaimNotesDialog: !this.state.openClaimNotesDialog });
  }

  toggleClaimFacilityNotesDialog() {
    this.setState({
      openClaimFacilityNotesDialog: !this.state.openClaimFacilityNotesDialog,
    });
  }

  toggleClaimDocumentsDialog() {
    this.setState({
      openClaimDocumentsDialog: !this.state.openClaimDocumentsDialog,
    });
  }

  toggleClaimExpenseDialog() {
    this.setState({
      openClaimExpenseDialog: !this.state.openClaimExpenseDialog,
      expanded: true,
    });
  }

  toggleEditClaimExpenseDialog() {
    this.setState({
      openEditClaimExpenseDialog: !this.state.openEditClaimExpenseDialog,
    });
  }

  // toggleWaitingPeriodApprovedDialog(){
  //   this.setState({ openClaimWaitingPeriodDialog: !this.state.openClaimWaitingPeriodDialog })
  // }

  toggleWaitingPeriodApprovedDialog = (open) => {
    this.setState({ openClaimWaitingPeriodDialog: open });
  };

  handleClaimExpense(payload) {
    this.props.dispatch(actions.createExpenseRequest(payload));
  }

  setClaimExpenseToDelete(expense) {
    this.props.dispatch(actions.setExpenseToDelete(expense));
  }
  deleteClaimExpense(expense) {
    this.props.dispatch(
      actions.deleteExpenseRequest({
        claim_guid: this.props.claimProcessingv2Data.claimsProcessingDcp.guid,
        expense_guid: expense.guid,
      })
    );
  }
  resetExpenseToDelete(expense) {
    this.props.dispatch(actions.resetExpenseToDelete(expense));
  }

  setClaimExpenseToEdit(expense) {
    this.props.dispatch(actions.setExpenseToEdit(expense));
  }

  editClaimExpense(payload) {
    this.props.dispatch(actions.expenseEditRequest(payload));
  }
  resetExpenseToEdit(expense) {
    this.props.dispatch(actions.resetExpenseEdit(expense));
  }
  handleClaimNotes(payload) {
    this.props.dispatch(actions.createClaimNote(payload));
  }

  handleClaimFacilityNotes(payload) {
    this.props.dispatch(actions.claimFacilityNotesRequest(payload));
  }

  deleteClaimDocument(document) {
    this.props.dispatch(
      actions.deleteclaimDocumentsRequest({
        claim_guid: this.props.claimProcessingv2Data.claimsProcessingDcp.guid,
        claim_doc_guid: document.guid,
      })
    );
  }
  setClaimDocumentToDelete(document) {
    this.props.dispatch(actions.setDocumentsToDelete(document));
  }

  resetDocumentToDelete(document) {
    this.props.dispatch(actions.resetDocumentToDelete(document));
  }
  getPreauthDetails(guid) {
    this.props.dispatch(actions.getPreauthDetailsRequest(guid));
  }

  isCashbackClaim(claim) {
    const hasCashbackBenefit = !!find(claim.benefits, { type: "Cashback" });
    return hasCashbackBenefit;
  }

  isFuneralNaturalClaim(claim) {
    const partnerGuid = getPartnerGuid();
    const hasFuneralNaturalDeath =
      partnerGuid === "omk"
        ? !!find(claim.benefits, { type: "Last_Expense" })
        : !!find(claim.benefits, { type: "Funeral Natural Death" });
    return hasFuneralNaturalDeath;
  }

  isFuneralAccidentalDeathClaim(claim) {

    const hasFuneralAccidentalDeath = !!find(claim.benefits, {
      type: "Funeral Accidental Death",
    }) || !!find(claim.benefits, {
      type: "Funeral_Accidental_Death",
    });
    return hasFuneralAccidentalDeath;
  }

  isHospiCashIllnessBenefitClaim(claim) {
    // Mthunzi exposes a single "Hospital Cash Benefit"; illness vs accident is
    // captured via cause of admission, not the benefit type.
    const hasHospiCashBenefit = !!find(claim.benefits, {
      type: "Hospital Cash Benefit",
    });
    const cause = claim.claim_details && claim.claim_details.additional_details
      ? claim.claim_details.additional_details.cause
      : null;
    return hasHospiCashBenefit && cause !== "accident";
  }

  isDeathClaim(claim) {
    const hasAccidentalDeath = !!find(claim.benefits, { type: "Accidental Death" }) || !!find(claim.benefits, { type: "Natural Death" }) || !!find(claim.benefits, { type: "Accidental_Death" }) || !!find(claim.benefits, { type: "Natural_Death" });
    return hasAccidentalDeath;
  }
  isDisabilityClaim(claim) {
    const hasPartialPermanentDisability = !!find(claim.benefits, { type: "Partial Permanent Disability" }) || !!find(claim.benefits, { type: "Total Permanent Disability" }) || !!find(claim.benefits, { type: "Partial_Permanent_Disability" }) || !!find(claim.benefits, { type: "Total_Permanent_Disability" });
    return hasPartialPermanentDisability;
  }



  isRewardsBenefitClaim(claim) {
    const hasRewardsBenefits = !!find(claim.benefits, { type: "Rewards" });
    return hasRewardsBenefits;
  }

  isHospiCashAccidentBenefitClaim(claim) {
    const hasHospiCashBenefit = !!find(claim.benefits, {
      type: "Hospital Cash Benefit",
    });
    const cause = claim.claim_details && claim.claim_details.additional_details
      ? claim.claim_details.additional_details.cause
      : null;
    return hasHospiCashBenefit && cause === "accident";
  }

  isOldMutualMalawiFuneralClaim(claim) {
    const hasOldMutualMalawiFuneralBenefits = !!find(claim.benefits, (benefit) => {
      return OLD_MUTUAL_MALAWI_FUNERAL_BENEFITS.includes(benefit.type)
    });
    return hasOldMutualMalawiFuneralBenefits;
  }





  isAccidentalDeathClaim(claim) {
    const hasAccidentalDeath = !!find(claim.benefits, { type: "Accidental Death" }) || !!find(claim.benefits, { type: "Accidental_Death" });
    return hasAccidentalDeath;
  }

  isNaturalDeathClaim(claim) {
    const hasNaturalDeath = !!find(claim.benefits, { type: "Natural Death" }) || !!find(claim.benefits, { type: "Natural_Death" });
    return hasNaturalDeath;
  }

  isPermanentDisabilityClaim(claim) {
    const hasPermanentDisability = !!find(claim.benefits, { type: "Total Permanent Disability" }) || !!find(claim.benefits, { type: "Total_Permanent_Disability" });
    return hasPermanentDisability;
  }

  isPartialPermanentDisabilityClaim(claim) {
    const hasPartialPermanentDisability = !!find(claim.benefits, { type: "Partial Permanent Disability" }) || !!find(claim.benefits, { type: "Partial_Permanent_Disability" });
    return hasPartialPermanentDisability;
  }

  getClaimType(claim) {
    if (!claim) return "";
    if (this.isCashbackClaim(claim)) return ClaimTypeEnum.Cashback;
    if (this.isFuneralNaturalClaim(claim))
      return ClaimTypeEnum.FuneralNaturalDeath;
    if (this.isFuneralAccidentalDeathClaim(claim))
      return ClaimTypeEnum.FuneralAccidentalDeath;
    if (this.isHospiCashIllnessBenefitClaim(claim))
      return ClaimTypeEnum.HospiCashIllness;
    if (this.isRewardsBenefitClaim(claim)) return ClaimTypeEnum.Rewards;
    if (this.isHospiCashAccidentBenefitClaim(claim))
      return ClaimTypeEnum.HospiCashAccident;
    if (this.isAccidentalDeathClaim(claim)) return ClaimTypeEnum.AccidentalDeath;
    if (this.isNaturalDeathClaim(claim)) return ClaimTypeEnum.NaturalDeath;
    if (this.isPermanentDisabilityClaim(claim)) return ClaimTypeEnum.TotalPermanentDisability;
    if (this.isPartialPermanentDisabilityClaim(claim)) return ClaimTypeEnum.PartialPermanentDisability;
    if (this.isOldMutualMalawiFuneralClaim(claim)) return ClaimTypeEnum.OldMutualMalawiFuneral;
    // if (this.isDeviceDamageClaim(claim)) return ClaimTypeEnum.deviceDamage
    // if (this.isParmanentDisabilityClaim(claim)) return ClaimTypeEnum.permanentDisability
    // if (this.isDeviceTheftClaim(claim)) return ClaimTypeEnum.deviceTheft
    // if (this.isTemporaryDisability(claim)) return ClaimTypeEnum.TemporaryDisability
    // if (this.isLastExpense(claim)) return ClaimTypeEnum.LastExpense
    // if (this.isProperty(claim)) return ClaimTypeEnum.Property
    // if(this.isCancer(claim)) return ClaimTypeEnum.Cancer

    return "";
  }
  viewCustomerProfile() {
    const customer_guid = this.props.claimProcessingv2Data.claimsProcessingDcp
      .customer_guid;
    if (customer_guid) {
      hashHistory.push("admin/customer_status/" + customer_guid);
    }
  }

  downloadClaimSummary() {
    this.setState({
      claimToDownload: this.props.claimProcessingv2Data.claimsProcessingDcp,
    });
  }
  render() {
    const partnerGuid = getPartnerGuid();
    const type = this.getClaimType(
      this.props.claimProcessingv2Data.claimsProcessingDcp
    );

    const benefits = this.props.claimProcessingv2Data.claimsProcessingDcp
      ? this.props.claimProcessingv2Data.claimsProcessingDcp.benefits
      : [];

    const hasCashbackBenefit = !!find(benefits, { type: "Cashback" });
    const hasFuneralNaturalDeath =
      partnerGuid === "omk"
        ? !!find(benefits, { type: "Last_Expense" })
        : !!find(benefits, { type: "Funeral Natural Death" });
    const hasFuneralAccidentalDeath = !!find(benefits, {
      type: "Funeral Accidental Death",
    }) || !!find(benefits, {
      type: "Funeral_Accidental_Death",
    });
    const hasHospiCashIllnessBenefit = !!find(benefits, {
      type: "Hospital Cash Benefit",
    });
    const hasRewardsBenefits = !!find(benefits, { type: "Rewards" });
    const hasHospiCashAccidentBenefit = !!find(benefits, {
      type: "Hospital Cash Benefit",
    });

    const CashbackBenefit = find(benefits, { type: "Cashback" });
    const FuneralNaturalDeath =
      partnerGuid === "omk"
        ? find(benefits, { type: "Last_Expense" })
        : find(benefits, { type: "Funeral Natural Death" });
    const FuneralAccidentalDeath = find(benefits, {
      type: "Funeral Accidental Death",
    })
    const HospiCashIllnessBenefit = find(benefits, {
      type: "Hospital Cash Benefit",
    });
    const RewardsBenefits = find(benefits, { type: "Rewards" });
    const HospiCashAccidentBenefit = find(benefits, {
      type: "Hospital Cash Benefit",
    });

    const hasAccidentalDeathBenefit = !!find(benefits, { type: "Accidental Death" }) || !!find(benefits, { type: "Accidental_Death" })
    const hasNaturalDeathBenefit = !!find(benefits, { type: "Natural Death" }) || !!find(benefits, { type: "Natural_Death" })
    const hasPartialPermanentDisabilityBenefit = !!find(benefits, { type: "Partial Permanent Disability" }) || !!find(benefits, { type: "Partial_Permanent_Disability" })
    const hasTotalPermanentDisabilityBenefit = !!find(benefits, { type: "Total Permanent Disability" }) || !!find(benefits, { type: "Total_Permanent_Disability" })
    const isMalawiFuneralClaim = !!find(benefits, (benefit) => {
      return OLD_MUTUAL_MALAWI_FUNERAL_BENEFITS.includes(benefit.type)
    })
    const isSambaFuneralClaim = !!find(benefits, { type: "Funeral" })



    if (!hasAuthourity("VIEW_CLAIM")) {
      return <p>You are unauthorized to view claim.</p>;
    }

    if (
      this.props.claimProcessingv2Data.get_claimsProcessingDcp_loader &&
      !this.props.claimProcessingv2Data.claimsProcessingDcp
    ) {
      return (
        <>
          <p>loading....</p>
        </>
      );
    }
    if (!this.props.claimProcessingv2Data.claimsProcessingDcp) {
      return (
        <>
          <p>nothing found </p>
        </>
      );
    }
    const templateDocuments = this.props.documentGenerationData
      .templateDocuments;


    const { policy } = this.state;
    const claim = this.props.claimProcessingv2Data.claimsProcessingDcp;



    const showAddInvoiceButton =
      partnerGuid === "omk"
        ? (!claim.is_on_grace_period || (policy && policy.status === "Full_Coverage"))
        : true; // For other partners, always show


    return (
      <>
        <ClaimHeader
          claimData={this.props.claimProcessingv2Data.claimsProcessingDcp}
        />
        <BoxInc
          title="Claims Details"
          expanded
          style={{ marginTop: "40px" }}
          actionButtons={[
            <ButtonInc
              variant="contained"
              color="primary"
              size="large"
              onClick={this.viewCustomerProfile.bind(this)}
            >
              View Customer Profile
            </ButtonInc>,
          ]}
        >
          <ClaimDetails
            claim={this.props.claimProcessingv2Data.claimsProcessingDcp}
            toggleClaimNotesDialog={this.toggleClaimNotesDialog.bind(this)}
            openClaimNotesDialog={this.state.openClaimNotesDialog}
            isHospiCashIllnessBenefitClaim={this.isHospiCashIllnessBenefitClaim.bind(
              this
            )}
            isHospiCashAccidentBenefitClaim={this.isHospiCashAccidentBenefitClaim.bind(
              this
            )}
            isFuneralAccidentalDeathClaim={this.isFuneralAccidentalDeathClaim.bind(
              this
            )}
            isFuneralNaturalClaim={this.isFuneralNaturalClaim.bind(this)}
            isDeathClaim={this.isDeathClaim.bind(this)}
            isDisabilityClaim={this.isDisabilityClaim.bind(this)}
            isOldMutualMalawiFuneralClaim={this.isOldMutualMalawiFuneralClaim.bind(this)}
          />
          <AddClaimFacilityNotes
            toggleClaimFacilityNotesDialog={this.toggleClaimFacilityNotesDialog.bind(
              this
            )}
            openClaimFacilityNotesDialog={
              this.state.openClaimFacilityNotesDialog
            }
            handleClaimFacilityNotes={this.handleClaimFacilityNotes.bind(this)}
            claimguid={
              this.props.claimProcessingv2Data.claimsProcessingDcp.guid
            }
            showCreateFacilityNoteProgressAlert={
              this.props.claimProcessingv2Data.ClaimFacilityNotesLoader
            }
            showCreateFacilityNotesSuccessAlert={
              this.props.claimProcessingv2Data.ClaimFacilityNotesSuccess
            }
            showCreateFacilityNotesErrorAlert={
              !!this.props.claimProcessingv2Data.ClaimFacilityNotesError
            }
            CreateFacilityNotesError={
              this.props.claimProcessingv2Data.ClaimFacilityNotesError
            }
            resetCreateFacilityNotesSuccessAlert={() => {
              this.props.dispatch(actions.resetFacilityClaimNotesSuccess());
            }}
            resetCreateFacilityNotesErrorAlert={() => {
              this.props.dispatch(actions.resetCreateExpenseError());
            }}
          />
        </BoxInc>
        <BoxInc title="Claims Documents " style={{ marginTop: "30px" }}>
          <AddClaimDocuments
            description={this.state.description}
            toggleClaimDocumentsDialog={this.toggleClaimDocumentsDialog.bind(
              this
            )}
            openClaimDocumentsDialog={this.state.openClaimDocumentsDialog}
            claim_guid={
              this.props.claimProcessingv2Data.claimsProcessingDcp.guid
            }
            saveClaimDocument={(doc) =>
              this.props.dispatch(actions.saveClaimDcpDocumentRequest(doc))
            }
            error={this.props.claimProcessingv2Data.saveClaimDcpDocumentError}
            requiredDocuments={normaliseChecklist(
              this.props.claimProcessingv2Data.claimsProcessingDcp
                .required_documents_checklist
            )}
          />
          <ClaimDocuments
            setDescription={(description) => this.setState({ description })}
            claimDocuments={
              this.props.claimProcessingv2Data.claimsProcessingDcp
                .claim_documents
            }
            setClaimDocumentToDelete={this.setClaimDocumentToDelete.bind(this)}
            setMissingDocs={(val) => this.setState({ missingDocs: val })}
            claimDetails={this.props.claimProcessingv2Data.claimsProcessingDcp}
            missingDocs={this.state.missingDocs}
            openUploadDialog={this.toggleClaimDocumentsDialog.bind(this)}
            type={type}
          />
          <DeleteClaimDocument
            DocumentToDelete={
              this.props.claimProcessingv2Data.documentsToDelete
            }
            deleteClaimDocument={this.deleteClaimDocument.bind(this)}
            resetDocumentToDelete={this.resetDocumentToDelete.bind(this)}
            showDeleteDocumentProgressAlert={
              this.props.claimProcessingv2Data.hardDeleteExpenseLoader
            }
            showDeleteDocumentSuccessAlert={
              this.props.claimProcessingv2Data.hardDeleteDocumentSuccess
            }
            showDeleteDocumentErrorAlert={
              !!this.props.claimProcessingv2Data.deleteClaimDocumentError
            }
            deleteDocumentError={
              this.props.claimProcessingv2Data.deleteClaimDocumentError
            }
            resetDeleteDocumentSuccessAlert={() => {
              this.props.dispatch(actions.resetHardDeleteDocumentSuccess());
            }}
            resetDeleteDocumentErrorAlert={() => {
              this.props.dispatch(actions.resetHardDeleteDocumentError());
            }}
          />
        </BoxInc>
        <ClaimChecks
          claim={this.props.claimProcessingv2Data.claimsProcessingDcp}
        />

        <BoxInc
          title={
            type === ClaimTypeEnum.death
              ? "Claim Benefits "
              : " Claim Invoices "
          }
          expanded={this.state.expanded}
          style={{ marginTop: "30px" }}
          actionButtons={[
            showAddInvoiceButton && (
              <ButtonInc
                variant="contained"
                color="primary"
                size="large"
                onClick={this.toggleClaimExpenseDialog.bind(this)}
                hasPermision={hasAuthourity("UPDATE_CLAIM")}
              >
                {type === ClaimTypeEnum.death
                  ? "Benefit Amount"
                  : " Add  invoice details"}
              </ButtonInc>
            ),
          ]}
        >
          <ClaimExpenses
            claimExpense={this.props.claimProcessingv2Data.claimsProcessingDcp}
            setClaimExpenseToDelete={this.setClaimExpenseToDelete.bind(this)}
            setClaimExpenseToEdit={this.setClaimExpenseToEdit.bind(this)}
            toggleEditClaimExpenseDialog={this.toggleEditClaimExpenseDialog.bind(
              this
            )}
            openEditClaimExpenseDialog={this.state.openEditClaimExpenseDialog}
            type={type}
            hasCashbackBenefit={hasCashbackBenefit}
            hasFuneralNaturalDeath={hasFuneralNaturalDeath}
            hasFuneralAccidentalDeath={hasFuneralAccidentalDeath}
            hasHospiCashIllnessBenefit={hasHospiCashIllnessBenefit}
            hasRewardsBenefits={hasRewardsBenefits}
            hasHospiCashAccidentBenefit={hasHospiCashAccidentBenefit}
            CashbackBenefit={CashbackBenefit}
            FuneralNaturalDeath={FuneralNaturalDeath}
            FuneralAccidentalDeath={FuneralAccidentalDeath}
            HospiCashIllnessBenefit={HospiCashIllnessBenefit}
            RewardsBenefits={RewardsBenefits}
            HospiCashAccidentBenefit={HospiCashAccidentBenefit}
            hasAccidentalDeathBenefit={hasAccidentalDeathBenefit}
            hasNaturalDeathBenefit={hasNaturalDeathBenefit}
            hasPartialPermanentDisabilityBenefit={hasPartialPermanentDisabilityBenefit}
            hasTotalPermanentDisabilityBenefit={hasTotalPermanentDisabilityBenefit}
            isOldMutualMalawiFuneralClaim={isMalawiFuneralClaim}
            downloadClaimSummary={this.downloadClaimSummary.bind(this)}
          />

          <AddClaimExpense
            toggleClaimExpenseDialog={this.toggleClaimExpenseDialog.bind(this)}
            openClaimExpenseDialog={this.state.openClaimExpenseDialog}
            claim={this.props.claimProcessingv2Data.claimsProcessingDcp}
            handleClaimExpense={this.handleClaimExpense.bind(this)}
            showCreateExpenseProgressAlert={
              this.props.claimProcessingv2Data.createdClaimExpenseLoader
            }
            showCreateExpenseSuccessAlert={
              this.props.claimProcessingv2Data.createdClaimExpenseSuccess
            }
            showCreateExpenseErrorAlert={
              !!this.props.claimProcessingv2Data.createdClaimExpenseError
            }
            CreateExpenseError={
              this.props.claimProcessingv2Data.createdClaimExpenseError
            }
            resetCreateExpenseSuccessAlert={() => {
              this.props.dispatch(actions.resetCreateExpenseSuccess());
            }}
            resetCreateExpenseErrorAlert={() => {
              this.props.dispatch(actions.resetCreateExpenseError());
            }}
            type={type}
            hasCashbackBenefit={hasCashbackBenefit}
            hasFuneralNaturalDeath={hasFuneralNaturalDeath}
            hasFuneralAccidentalDeath={hasFuneralAccidentalDeath}
            hasHospiCashIllnessBenefit={hasHospiCashIllnessBenefit}
            hasRewardsBenefits={hasRewardsBenefits}
            hasHospiCashAccidentBenefit={hasHospiCashAccidentBenefit}
            hasAccidentalDeathBenefit={hasAccidentalDeathBenefit}
            hasNaturalDeathBenefit={hasNaturalDeathBenefit}
            hasPartialPermanentDisabilityBenefit={hasPartialPermanentDisabilityBenefit}
            hasTotalPermanentDisabilityBenefit={hasTotalPermanentDisabilityBenefit}
            isOldMutualMalawiFuneralClaim={isMalawiFuneralClaim}
            isSambaFuneralClaim={isSambaFuneralClaim}
          />
          <DeleteClaimExpense
            expenseToDelete={this.props.claimProcessingv2Data.expenseToDelete}
            deleteClaimExpense={this.deleteClaimExpense.bind(this)}
            resetExpenseToDelete={this.resetExpenseToDelete.bind(this)}
            showDeleteExpenseProgressAlert={
              this.props.claimProcessingv2Data.hardDeleteExpenseLoader
            }
            showDeleteExpenseSuccessAlert={
              this.props.claimProcessingv2Data.hardDeleteExpenseSuccess
            }
            showDeleteExpenseErrorAlert={
              !!this.props.claimProcessingv2Data.deleteExpenseErrors
            }
            deleteExpenseError={
              this.props.claimProcessingv2Data.deleteExpenseErrors
            }
            resetDeleteExpenseSuccessAlert={() => {
              this.props.dispatch(actions.resetHardDeleteExpenseSuccess());
            }}
            resetDeleteExpenseErrorAlert={() => {
              this.props.dispatch(actions.resetHardDeleteExpenseError());
            }}
          />

          <EditClaimDetails
            toggleEditClaimExpenseDialog={this.toggleEditClaimExpenseDialog.bind(
              this
            )}
            openEditClaimExpenseDialog={this.state.openEditClaimExpenseDialog}
            expenseToEdit={this.props.claimProcessingv2Data.ExpenseToEdit}
            editClaimExpense={this.editClaimExpense.bind(this)}
            resetExpenseToEdit={this.resetExpenseToEdit.bind(this)}
            showEditExpenseProgressAlert={
              this.props.claimProcessingv2Data.loader
            }
            showEditExpenseSuccessAlert={
              this.props.claimProcessingv2Data.editExpenseSuccess
            }
            showEditExpenseErrorAlert={
              !!this.props.claimProcessingv2Data.editExpenseErrors
            }
            editExpenseError={
              this.props.claimProcessingv2Data.editExpenseErrors
            }
            resetEditExpenseSuccessAlert={() => {
              this.props.dispatch(actions.resetExpenseEditSuccess());
            }}
            resetEditExpenseErrorAlert={() => {
              this.props.dispatch(actions.resetExpenseEditError());
            }}
            claimguid={
              this.props.claimProcessingv2Data.claimsProcessingDcp.guid
            }
          />
        </BoxInc>
           <BoxInc
          title="Claim Notes"
          style={{ marginTop: "30px" }}
          actionButtons={[
            <ButtonInc
              variant="contained"
              color="primary"
              size="large"
              onClick={this.toggleClaimNotesDialog.bind(this)}
              hasPermision={hasAuthourity('UPDATE_CLAIM')}
            >
              Add Note
            </ButtonInc>,
          ]}
        >
          <ClaimNotes
            claim={this.props.claimProcessingv2Data.claimsProcessingDcp}
          />
          <AddClaimNotes
            toggleClaimNotesDialog={this.toggleClaimNotesDialog.bind(this)}
            openClaimNotesDialog={this.state.openClaimNotesDialog}
            handleClaimNotes={this.handleClaimNotes.bind(this)}
            claimguid={
              this.props.claimProcessingv2Data.claimsProcessingDcp.guid
            }
            showCreateNoteProgressAlert={
              this.props.claimProcessingv2Data.createClaimNoteLoader
            }
            showCreateNotesSuccessAlert={
              this.props.claimProcessingv2Data.createClaimNoteSuccess
            }
            showCreateNotesErrorAlert={
              !!this.props.claimProcessingv2Data.createClaimNoteError
            }
            CreateNotesError={this.props.claimProcessingv2Data.createClaimNoteError}
            resetCreateNotesSuccessAlert={() => {
              this.props.dispatch(actions.resetCreateClaimNoteSuccess());
            }}
            resetCreateNotesErrorAlert={() => {
              this.props.dispatch(actions.resetCreateClaimNoteError());
            }}
          />
        </BoxInc>

        <BoxInc
          title="Claims Audit"
          expanded
          style={{ marginTop: "40px" }}
          actionButtons={[
            <ButtonInc
              variant="contained"
              color="primary"
              size="large"
              onClick={this.viewCustomerProfile.bind(this)}
            >
              View Customer Profile
            </ButtonInc>,
          ]}
        >
          <ClaimAudit
            claimGuid={this.props.claimProcessingv2Data.claimsProcessingDcp.guid}

          />

        </BoxInc>

     

        <WaitingPeriodApprovalReason
          toggleWaitingPeriodApprovedDialog={this.toggleWaitingPeriodApprovedDialog.bind(
            this
          )}
          openClaimWaitingPeriodDialog={this.state.openClaimWaitingPeriodDialog}
          toggleClaimNotesDialog={this.toggleClaimNotesDialog.bind(this)}
          handleClaimNotes={this.handleClaimNotes.bind(this)}
          claimguid={this.props.claimProcessingv2Data.claimsProcessingDcp.guid}
          showCreateNoteProgressAlert={
            this.props.claimProcessingv2Data.createClaimNoteLoader
          }
          showCreateNotesSuccessAlert={
            this.props.claimProcessingv2Data.createClaimNoteSuccess
          }
          showCreateNotesErrorAlert={
            !!this.props.claimProcessingv2Data.createClaimNoteError
          }
          CreateNotesError={this.props.claimProcessingv2Data.createClaimNoteError}
          resetCreateNotesSuccessAlert={() => {
            this.props.dispatch(actions.resetCreateClaimNoteSuccess());
          }}
          resetCreateNotesErrorAlert={() => {
            this.props.dispatch(actions.resetCreateClaimNoteError());
          }}
          submitClaimAction={this.handleSubmitClaimAction.bind(this)}
        />

        <DownloadDocument
          labels={this.state.labels}
          identifier="Claims"
          entityDocument={this.props.documentGenerationData.entityDocument}
          entity={this.state.claimToDownload}
          resetEntity={() => this.setState({ claimToDownload: null })}
          templates={templateDocuments}
          getTemplates={() =>
            this.props.dispatch(
              documentActions.getTemplateDocumentsRequest("Claim")
            )
          }
          getTemplatesLoader={
            this.props.documentGenerationData.getTemplateDocumentloader
          }
          isEmptyTemplatesResponse={
            this.props.documentGenerationData.isEmptyTemplates
          }
          downloadDocument={(guid) => {
            this.props.dispatch(
              documentActions.downloadDocumentRequest({
                entity_guid: this.state.claimToDownload.guid,
                template_guid: guid,
              })
            );
          }}
          resetGetTemplateDocuments={() => {
            this.props.dispatch(documentActions.resetGetTemplateDocuments());
          }}
          resetDownloadDocument={() => {
            this.props.dispatch(documentActions.resetDocumentEntity());
          }}
          showDownloadDocumentProgressAlert={
            this.props.documentGenerationData.downloadDocumentLoader
          }
          showDownloadDocumentSuccessAlert={
            this.props.documentGenerationData.downloadDocumentSuccess
          }
          showDownloadDocumentErrorAlert={
            !!this.props.documentGenerationData.downloadDocumentError
          }
          downloadDocumentError={
            this.props.documentGenerationData.downloadDocumentError
          }
          resetDownloadDocumentSuccessAlert={() => {
            this.props.dispatch(documentActions.resetDownloadDocumentSuccess());
          }}
          resetDownloadDocumentErrorAlert={() => {
            this.props.dispatch(documentActions.resetDownloadDocumentError());
          }}
          goToTemplatesPage={() => {
            hashHistory.push("admin/view_doc_templates");
          }}
        />

        {hasAuthourity("UPDATE_CLAIM") && (
          <ClaimActionButtons
            claim={this.props.claimProcessingv2Data.claimsProcessingDcp}
            submitClaimAction={this.handleSubmitClaimAction.bind(this)}
            loading={this.props.claimProcessingv2Data.ClaimActionLoader}
            error={this.props.claimProcessingv2Data.ClaimActionError}
            missingDocs={this.state.missingDocs}
            toggleWaitingPeriodApprovedDialog={this.toggleWaitingPeriodApprovedDialog.bind(
              this
            )}
          />
        )}

        <AutoInvoiceSummary
          open={this.state.autoInvoiceSummary.open}
          creating={this.state.autoInvoiceSummary.creating}
          total={this.state.autoInvoiceSummary.total}
          created={this.state.autoInvoiceSummary.created}
          failures={this.state.autoInvoiceSummary.failures}
          invoiceNumber={this.state.autoInvoiceSummary.invoiceNumber}
          onClose={() =>
            this.setState({
              autoInvoiceSummary: {
                ...this.state.autoInvoiceSummary,
                open: false,
              },
            })
          }
        />
      </>
    );
  }
}
export default connect((state) => ({
  customerData: state.currentCustomer,
  documentGenerationData: state.documentGeneration,
  claimProcessingv2Data: state.claimProcessingv2Data,
  claimDashboardData: state.claimDashboardData,
  globalData: state.global,
}))(ClaimsProcessing);